export default __webpack_public_path__ + "61971ff4ef0273d91fdf779d1fb89304.png";